import { create } from "zustand";
import { FlareStoreProps } from "./interface/flare-heating-store.interface";
import { CreateHeatingValue, FilterSetupHeatingValue, UpdateHeatingValue } from "src/entity/flare/heating-value.entity";
import {
  clearReportValueByGasName,
  createSetupHeatingValue,
  deleteSetupHeatingValue,
  getAllSettingFlareCompound,
  getFilterSetupHeatingValue,
  getYearHeatingValue,
  searchSetupHeatingValue,
  updateSetupHeatingValue,
} from "src/services/flare.service";
import { ClearReportValueBody } from "src/entity/flare/flare-volume.entity";

const getInitialFilter = () => ({
  gasName: [],
  composition: [],
  netHeatingValue: [],
});

export const flareHeatingStore = create<FlareStoreProps>((set) => ({
  loadingAll: false,
  loadingGetMaster: false,
  loadingHeating: false,
  loadingManageHeating: false,
  loadingCompound: false,
  dataHeating: {
    total: 0,
    data: [],
  },
  errorHeating: null,
  filterHeatingValue: {
    gasName: [],
    composition: [],
    netHeatingValue: [],
  },
  dataYear: [],
  dataCompound: [],
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setHeatingLoading: (loading: boolean) => {
    set(() => ({ loadingAll: loading }));
  },
  getAllSettingFlareCompound: async (filter?: { isActive: boolean }) => {
    set(() => ({ loadingCompound: true }));
    try {
      const response = await getAllSettingFlareCompound(filter);

      set(() => ({ loadingCompound: false, dataCompound: response.data?.data ?? [] }));
    } catch (error) {
      console.log();
    } finally {
      set(() => ({ loadingCompound: false }));
    }
  },
  getYear: async (companyId: string) => {
    try {
      const currentYear = new Date().getFullYear();
      const response = await getYearHeatingValue(companyId);

      set(() => ({ dataYear: response.data?.data && response.data.data.length == 0 ? [currentYear.toString()] : response.data.data }));
    } catch (error) {
      console.log();
    }
  },
  getFilterSetupHeatingValue: async (year: string) => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const res = await getFilterSetupHeatingValue({ year });
      set((state) => ({
        loadingGetMaster: false,
        filterHeatingValue: res.data?.data,
      }));
    } catch (err: any) {
      set((state) => ({
        loadingGetMaster: false,
        filterHeatingValue: getInitialFilter(),
      }));
    }
  },
  searchSetupHeatingValue: async (filter: FilterSetupHeatingValue) => {
    if (!filter?.year || filter.year.length === 0) return;
    set(() => ({ loadingHeating: true }));
    try {
      const res = await searchSetupHeatingValue(filter);
      set(() => ({ loadingHeating: false, dataHeating: res.data?.data }));
    } catch (err: any) {
      set(() => ({ loadingHeating: false, error: err?.message, dataHeating: { data: [], total: 0 } }));
    }
  },
  createSetupHeatingValue: async (body: CreateHeatingValue) => {
    set(() => ({ loadingManageHeating: true }));
    try {
      await createSetupHeatingValue(body);
      set(() => ({ loadingManageHeating: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageHeating: false, errorHeating: message }));
      return message;
    }
  },
  updateSetupHeatingValue: async (body: UpdateHeatingValue) => {
    set(() => ({ loadingManageHeating: true }));
    try {
      await updateSetupHeatingValue(body);
      set(() => ({ loadingManageHeating: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageHeating: false, errorHeating: message }));
      return message;
    }
  },
  deleteSetupHeatingValue: async (id: string) => {
    set(() => ({ loadingManageHeating: true }));
    try {
      const res = await deleteSetupHeatingValue(id);
      set(() => ({ loadingManageHeating: false }));
    } catch (err: any) {
      set(() => ({ loadingManageHeating: false, errorHeating: err?.message }));
    }
  },
  clearReportValueByGasName: async (body: ClearReportValueBody) => {
    set(() => ({ loadingManageHeating: true }));
    try {
      const res = await clearReportValueByGasName(body);
      set(() => ({ loadingManageHeating: false }));
    } catch (err: any) {
      set(() => ({ loadingManageHeating: false, errorHeating: err?.message }));
    }
  },
}));
